export default __webpack_public_path__ + "static/mobile-logo-34674fa194b284cd1dde03d53e51bf24.svg";